import { useState } from "react";
import Api from "../../api/api";
import stringHelpers from "../../../utilities/stringHelpers";
import { dateRange } from "../../../utilities/dateUtilities";
import Enums from "../../../utilities/enum";
import { ScheduleExportDateRangePicker, isScheduleDateRangeCustomRangeInvalid } from "../scheduleExportDateRangePicker";
import { SearchSelect } from "../../shared/searchSelect";
import { ScheduleExportModal } from "../../shared/scheduleExportModal";
import { TagSelector } from "../../shared/tagSelector";
import arrayUtilities from "../../../utilities/arrayUtilities";

export const exportBreachesReportType = 0

export const ExportBreachesScheduleModal = ({ tags = [], organisationId, token, onCancel, onSaved, scheduledExport, initialParameters }) => {
    const seedParameters = scheduledExport?.parameters ?? initialParameters ?? {}
    const hasCustomDates = seedParameters.from != null || seedParameters.to != null
    const isEditing = !stringHelpers.isNullOrEmpty(scheduledExport?.id)

    const [scheduleFromDate, setScheduleFromDate] = useState(seedParameters.from ?? dateRange("lastMonth").firstDate)
    const [scheduleToDate, setScheduleToDate] = useState(seedParameters.to ?? dateRange("lastMonth").lastDate)
    const [scheduledDateRangeTypePreset, setScheduledDateRangeTypePreset] = useState(seedParameters.reportDatePreset || (hasCustomDates ? null : 0))
    const [scheduleSelectedStatus, setScheduleSelectedStatus] = useState(seedParameters.breachStatus ?? 0)
    const [scheduleSelectedTags, setScheduleSelectedTags] = useState(seedParameters.tagIds ?? [])
    const [isSaving, setIsSaving] = useState(false)
    const [saveErrorMessage, setSaveErrorMessage] = useState(null)

    const isScheduleCustomDateRangeInvalid = isScheduleDateRangeCustomRangeInvalid(scheduledDateRangeTypePreset, scheduleFromDate, scheduleToDate)
    const isSubmitDisabled = isScheduleCustomDateRangeInvalid || isSaving

    const buildScheduledExportParameters = () => {
        const isUsingDateRangePreset = scheduledDateRangeTypePreset !== null
        const dateRangeParameters = isUsingDateRangePreset
            ? { reportDatePreset: scheduledDateRangeTypePreset }
            : { from: scheduleFromDate, to: scheduleToDate }

        return {
            ...dateRangeParameters,
            breachStatus: Number(scheduleSelectedStatus),
            tagIds: !arrayUtilities.isNullOrEmpty(scheduleSelectedTags) ? scheduleSelectedTags : null,
        }
    }

    const handleSaveFailed = (error) => {
        setSaveErrorMessage(error?.errorMessage ?? "Unable to save scheduled export")
        setIsSaving(false)
    }

    const handleSaveSucceeded = (data) => {
        if (data?.isError) {
            handleSaveFailed(data)
        } else {
            onSaved()
        }
    }

    return (
        <ScheduleExportModal
            initialValues={ scheduledExport }
            reportType={ exportBreachesReportType }
            onCancel={ onCancel }
            disableConfirm={ isSubmitDisabled }
            errorMessage={ saveErrorMessage }
            onSubmit={ (isActive, name, scheduleFrequencyMode, monday, tuesday, wednesday, thursday, friday, saturday, sunday, dayOfMonth, time, recipients) => {
                setIsSaving(true)
                setSaveErrorMessage(null)
                if (isEditing) {
                    Api.updateScheduledExport(
                        handleSaveSucceeded,
                        handleSaveFailed,
                        scheduledExport.id,
                        name, exportBreachesReportType, scheduleFrequencyMode,
                        monday,
                        tuesday,
                        wednesday,
                        thursday,
                        friday,
                        saturday,
                        sunday,
                        time,
                        dayOfMonth,
                        recipients,
                        buildScheduledExportParameters(),
                        isActive,
                        organisationId, token
                    )
                } else {
                    Api.createScheduledExport(
                        handleSaveSucceeded,
                        handleSaveFailed,
                        name, exportBreachesReportType, scheduleFrequencyMode,
                        monday,
                        tuesday,
                        wednesday,
                        thursday,
                        friday,
                        saturday,
                        sunday,
                        time,
                        dayOfMonth,
                        recipients,
                        buildScheduledExportParameters(),
                        isActive,
                        organisationId, token
                    )
                }
            } }
        >
            <div className="">
                <h5 className="mb-2">Filters</h5>
                <div className="row mb-2">
                    <div className="col-md-3">Date Range</div>
                    <div className="col-md-9">
                        <ScheduleExportDateRangePicker
                            scheduledDateRangeTypePreset={ scheduledDateRangeTypePreset }
                            setScheduledDateRangeTypePreset={ setScheduledDateRangeTypePreset }
                            scheduleFromDate={ scheduleFromDate }
                            setScheduleFromDate={ setScheduleFromDate }
                            scheduleToDate={ scheduleToDate }
                            setScheduleToDate={ setScheduleToDate }
                        />
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-md-3">Status</div>
                    <div className="col-md-9">
                        <SearchSelect
                            width="100%"
                            options={ Object.entries(Enums.BreachStatus).map(([key, value]) => ({ value: key, label: value })) }
                            onSelect={ value => setScheduleSelectedStatus(Number(value)) }
                            selected={ String(scheduleSelectedStatus) }
                        />
                    </div>
                </div>
                { !arrayUtilities.isNullOrEmpty(tags) && <div className="row mb-2">
                    <div className="col-md-3">Tags</div>
                    <div className="col-md-9">
                        <TagSelector
                            onChange={ tagSelections => setScheduleSelectedTags(tagSelections) }
                            selectedTags={ scheduleSelectedTags }
                            tags={ tags }
                        />
                    </div>
                </div> }
            </div>
            <hr className="border-dashed border-bottom-0"></hr>
        </ScheduleExportModal>
    )
}
